/* tslint:disable */
/* eslint-disable */
export enum JofiUserTypeEnum {
  Student = 'STUDENT',
  Recruiter = 'RECRUITER',
  Admin = 'ADMIN'
}
